import { render, staticRenderFns } from "./EndorsementForm.vue?vue&type=template&id=2e437684"
import script from "./EndorsementForm.vue?vue&type=script&lang=js"
export * from "./EndorsementForm.vue?vue&type=script&lang=js"
import style0 from "./EndorsementForm.vue?vue&type=style&index=0&id=2e437684&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports